import { Stack } from '@mui/material'
import { Body, H2 } from 'components/styledFonts'
import Block from 'components/Block'


const Keywords = ({ keywords }) => {

    if (!keywords) return null

    return (
        <Block>
            <Stack
                gap={2}
            >
                <H2>検索キーワード</H2>
                <Stack
                    sx={{
                        gap: 1,
                        pl: 2,
                        overflowWrap: "anywhere",
                        wordBreak: "normal",
                        lineBreak: "strict",
                    }}
                >
                    <Body
                        sx={{ lineHeight: 2 }}
                    >
                        {keywords.trim().split(/\s+/).join('\u3000')}
                    </Body>
                </Stack>
            </Stack>
        </Block>
    )
}

export default Keywords
